// extracted by mini-css-extract-plugin
export default {"text-area":"text-area_text-area__ZiP60"};